import { DateRange } from '@angular/material/datepicker';
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  ChartSelectedProperties,
  EnergyStorageTrendingLabel,
  TrendingData,
  TrendingResolution,
  TrendingTab,
  TrendingType,
} from './trending.model';
import { ViError } from '@vi-iot/client/models';

export namespace TrendingActions {
  export enum Type {
    GET_DATA_SERIES = '[TRENDING] Get data series',
    GET_DATA_SERIES_SUCCESS = '[TRENDING] Get data series success',
    GET_DATA_SERIES_ERROR = '[TRENDING] Get data series error',
    SET_DATE_RANGE = '[TRENDING] Set date range',
    SET_RESOLUTION = '[TRENDING] Set resolution',
    SELECT_CHART_PROPERTIES = '[TRENDING] Select chart properties',
    CLEAR_STORE = '[TRENDING] Clear store',
    SET_NAVIGATOR_EXTREME = '[TRENDING] Set Navigator Extremes',
    SELECT_ACTIVE_TRENDING_TYPE = '[TRENDING] Select Active Trending Type',
  }

  export const getDataSeries = createAction(Type.GET_DATA_SERIES);

  export const getDataSeriesSuccess = createAction(
    Type.GET_DATA_SERIES_SUCCESS,
    props<{
      dataSeries: TrendingData;
    }>()
  );

  export const getDataSeriesError = createAction(
    Type.GET_DATA_SERIES_ERROR,
    props<{
      error: any;
    }>()
  );

  export const selectChartProperties = createAction(
    Type.SELECT_CHART_PROPERTIES,
    props<{
      chartProperties: ChartSelectedProperties;
    }>()
  );

  export const setDateRange = createAction(
    Type.SET_DATE_RANGE,
    props<{
      dateRange: DateRange<Date>;
    }>()
  );

  export const setResolution = createAction(
    Type.SET_RESOLUTION,
    props<{
      resolution: TrendingResolution;
    }>()
  );

  export const clearStore = createAction(Type.CLEAR_STORE);

  export const setNavigatorExtremes = createAction(
    Type.SET_NAVIGATOR_EXTREME,
    props<{ min: number; max: number }>()
  );

  export const setActiveTrendingType = createAction(
    Type.SELECT_ACTIVE_TRENDING_TYPE,
    props<{
      trendingType: TrendingType;
    }>()
  );

  export const selectTrendingTabData = createActionGroup({
    source: '[TRENDING] Get Trending Tab Data',
    events: {
      attempt: emptyProps(),
      success: props<{ trendingTabData: TrendingTab[] }>(),
    },
  });

  export const getEnergyStorageLabels = createActionGroup({
    source: '[TRENDING] Get Energy Storage Labels',
    events: {
      attempt: emptyProps(),
      success: props<{ energyStorageTrendingLabel: EnergyStorageTrendingLabel }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });
}
